// extracted by mini-css-extract-plugin
export default {"subTabMenu":"SubTabMenu_subTabMenu__u97T-","active":"SubTabMenu_active__pkl-B"};